import { InfoCircleOutlined } from '@ant-design/icons';
import { useMemo } from 'react';

import { Flex } from '@/components/base';
import TooltipV2 from '@/components/Tooltip/TooltipV2';

const SourceStatusColumnHeader = () => {
  const tooltipNode = useMemo(() => {
    return (
      <Flex>
        Source status
        <br />
        indicates the current
        <br />
        status of each ticket
        <br />
        from the source.
      </Flex>
    );
  }, []);
  return (
    <Flex a="center" g={8}>
      Source Status
      <TooltipV2 tooltipNode={tooltipNode}>
        <InfoCircleOutlined />
      </TooltipV2>
    </Flex>
  );
};

const FeedbackStatusColumnHeader = () => {
  const tooltipNode = useMemo(() => {
    return (
      <Flex>
        AI status indicates
        <br />
        the current progress
        <br />
        of AI analysis of each
        <br />
        ticket by Syncly.
      </Flex>
    );
  }, []);
  return (
    <Flex a="center" g={8}>
      AI Status
      <TooltipV2 tooltipNode={tooltipNode}>
        <InfoCircleOutlined />
      </TooltipV2>
    </Flex>
  );
};

export { FeedbackStatusColumnHeader,SourceStatusColumnHeader };
